import { render, staticRenderFns } from "./HotkeyListener.vue?vue&type=template&id=0a5ac084&scoped=true&"
import script from "./HotkeyListener.vue?vue&type=script&lang=ts&"
export * from "./HotkeyListener.vue?vue&type=script&lang=ts&"
import style0 from "./HotkeyListener.vue?vue&type=style&index=0&id=0a5ac084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5ac084",
  null
  
)

export default component.exports